<!-- Galleria Component - Image Gallery with PrimeNG -->
@if (hasImages()) {
  <p-galleria
    data-testid="galleria-container"
    [value]="images"
    [activeIndex]="activeIndex()"
    [visible]="isVisible()"
    [showThumbnails]="defaultConfig().showThumbnails"
    [showThumbnailNavigators]="defaultConfig().showThumbnailNavigators"
    [autoPlay]="defaultConfig().autoPlay"
    [circular]="defaultConfig().circular"
    [numVisible]="defaultConfig().numVisible"
    [transitionInterval]="defaultConfig().transitionInterval"
    [responsiveOptions]="defaultConfig().responsiveOptions"
    (onImageChange)="onImageChange($event)"
    (onImageSelect)="onImageSelect($event)"
    (onShow)="onShow()"
    (onHide)="onHide()"
    [containerStyle]="{
      'max-width': '600px',
      height: '160px',
      padding: '12px',
    }"
  >
    <!-- Main Image Template -->
    <ng-template pTemplate="item" let-item let-index="index">
      @if (item.isVideo && item.videoUrl && isVideoBroken(index)) {
        <div
          [attr.data-testid]="'galleria-main-video-error-' + index"
          class="galleria-video-error"
          style="width: 100%; height: 80px; display: flex; align-items: center; justify-content: center"
        >
          <p>{{ "common.galleria.video_load_error" | translate }}</p>
        </div>
      } @else if (item.isVideo && item.videoUrl) {
        <video
          [attr.data-testid]="'galleria-main-video-' + index"
          [src]="item.videoUrl"
          [title]="getImageTitle(item)"
          controls
          preload="metadata"
          [attr.aria-label]="getAriaLabel(item)"
          style="width: 100%; height: 80px; object-fit: contain"
          (error)="onVideoError($event, index)"
        >
          @if (item.captionSrc) {
            <track
              kind="captions"
              [src]="item.captionSrc"
              [srclang]="item.captionLang"
              [label]="item.captionLabel"
              default
            />
          }
          <p>{{ "common.galleria.video_not_supported" | translate }}</p>
        </video>
      } @else {
        <img
          [attr.data-testid]="'galleria-main-image-' + index"
          [src]="item.src"
          [alt]="buildAltText(item)"
          [title]="getImageTitle(item)"
          [attr.aria-label]="getAriaLabel(item)"
          style="width: 100%; height: 80px; object-fit: contain"
        />
      }
    </ng-template>

    <!-- Thumbnail Template -->
    <ng-template pTemplate="thumbnail" let-item let-index="index">
      <button
        [attr.data-testid]="'galleria-thumbnail-btn-' + index"
        type="button"
        class="galleria-thumbnail-wrapper"
        (click)="onThumbnailClick(index)"
        (keydown.enter)="onThumbnailClick(index)"
        (keydown.space)="onThumbnailClick(index)"
        [attr.aria-label]="'Select thumbnail ' + (index + 1)"
      >
        @if (item.isVideo && item.videoUrl && !isVideoBroken(index)) {
          <video
            [attr.data-testid]="'galleria-thumbnail-video-' + index"
            [src]="item.videoUrl"
            preload="metadata"
            muted
            [attr.aria-label]="getThumbnailAriaLabel(item)"
            (error)="onVideoError($event, index)"
          >
            @if (item.captionSrc) {
              <track
                kind="captions"
                [src]="item.captionSrc"
                [srclang]="item.captionLang"
                [label]="item.captionLabel"
                default
              />
            }
            <track
              kind="descriptions"
              [src]="item.descriptionSrc || item.captionSrc"
              [srclang]="item.captionLang || 'en'"
              [label]="item.descriptionLabel || 'Description'"
            />
          </video>
        } @else {
          <img
            [attr.data-testid]="'galleria-thumbnail-image-' + index"
            [src]="item.thumbnail || item.src"
            [alt]="'img'"
          />
        }
      </button>
    </ng-template>
  </p-galleria>
} @else if (showEmptyState) {
  <!-- Empty State -->
  <div data-testid="galleria-empty-state" class="galleria-empty-state">
    <div data-testid="galleria-empty-icon" class="galleria-empty-icon">
      <i class="pi pi-image"></i>
    </div>
    <h3 data-testid="galleria-empty-title" class="galleria-empty-title">
      {{ "common.galleria.no_images_title" | translate }}
    </h3>
    <p
      data-testid="galleria-empty-description"
      class="galleria-empty-description"
    >
      {{ emptyMessage | translate }}
    </p>
  </div>
}

<!-- Screen Reader Only Content -->
<div
  data-testid="galleria-screen-reader-status"
  class="sr-only"
  aria-live="polite"
  aria-atomic="true"
>
  @if (hasImages()) {
    {{
      "common.galleria.image_gallery_info"
        | translate
          : {
              current: activeIndex() + 1,
              total: images.length,
              currentImage: buildAltText(images[activeIndex()]),
            }
    }}
  }
</div>
